export default {
  mediaSalesByChannel: 'Media {kpi} by Channel',
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image'
}
